import { useContext } from "react"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { shemaFileUpladerFormAllowEmpty } from "config/ShemaForms"
import { AuthContext } from "context/context/AuthContext"
import { FilesFormType } from "types/FilesFormType"
import { clients } from "webapp-clients/Clients"

/**
 * Form config to use in  Upload files
 *
 * @version 1.0.1
 * @author Naldo Duran <naldorck@gmail.com>
 * @param {} 
 * 
 *
 * @returns {object} 
 */

const useFormConfig = () => {
  const {
    state: { user },
  } = useContext(AuthContext)

  // TODO: Refactor multiclient
  const client = clients[user?.mainGroup.id as keyof typeof clients]
  const FileUpload = client["FileUpload" as keyof typeof client]

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<FilesFormType>({
    resolver: !!FileUpload ? yupResolver(shemaFileUpladerFormAllowEmpty([])) : undefined,
  })

  return {
    errors,
    FileUpload,
    watch,
    handleSubmit,
    register,
    setValue,
  }
}

export default useFormConfig
